var eventEmitter = {
    __createElement: function() { 
        this.__ele = document.createElement('div');
    },
    dispatchEvent: function(type, detail, options) {
        if(this.hasOwnProperty('__ele') == false)
            this.__createElement();
        options = options ?? {};
        if(detail != null)
            options.detail = detail;

        let event = new CustomEvent(type, options);
        this.__ele.dispatchEvent(event);
    },
    addEventListener: function(type, listener, options) {
        if(this.hasOwnProperty('__ele') == false)
            this.__createElement();
        this.__ele.addEventListener(type, listener, options);
    },
    removeEventListener: function(type, listener, options) {
        if(this.hasOwnProperty('__ele') == false)
            this.__createElement();
        this.__ele.removeEventListener(type, listener, options);
    },
    install: function(obj) {
        if(Object.getPrototypeOf(obj).hasOwnProperty('__createElement') == false) {
            for(var k in this)
                Object.getPrototypeOf(obj)[k] = this[k];
        }
    }
}

export default eventEmitter;